import qs from 'qs'
import axios from '../index'
/**
 * @description 判断用户是否登录 获取用户的身份
 * @author  cc
 * @date 2019-10-24
 * @export
 */
export function selfInvoice (params) {
  return axios.post('/user/self-invoice', qs.stringify(params))
}
